import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Place} from '../models/place';
import {Room} from '../models/room';

export interface MapMark {
  latitude: number;
  longitude: number;
  isOpen: boolean;
  place: Place;
  rooms?: Room[];
}

export interface MapState {
  latitude: number;
  longitude: number;
  zoom: number;
  marks: MapMark[];
  softBound: boolean;
  hardBound: boolean
}

@Injectable({
  providedIn: 'root'
})
export class MapService {
  mapState$ = new BehaviorSubject<MapState | null>(null);

  constructor() {
  }

  setMapState(latitude: number, longitude: number, zoom: number, marks: MapMark[], softBound: boolean = false, hardBound: boolean = false) {
    this.mapState$.next({latitude, longitude, zoom, marks, softBound, hardBound});
  }

}
